/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */

import PaletteIconArrowLeft from '@telus-uds/palette-allium/build/rn/icons/ArrowLeft'
import PaletteIconArrowRight from '@telus-uds/palette-allium/build/rn/icons/ArrowRight'
const theme = {
  appearances: {
    compact: {
      description: 'Determines if the "Next" and "Previous" labels should be omitted',
      type: 'state',
      values: [ true ]
    },
    direction: {
      description: "Determines which way does the button navigate in Pagination's context",
      type: 'state',
      values: [ 'previous', 'next' ]
    },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    selected: {
      description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
      type: 'state',
      values: [ true ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    { if: { compact: true }, tokens: { displayLabel: false } },
    {
      if: { viewport: [ 'xs', 'sm' ] },
      tokens: {
        borderRadius: 32,
        displayLabel: false,
        paddingBottom: 4,
        paddingTop: 4,
        width: 32
      }
    },
    {
      if: { hover: true },
      tokens: {
        iconDisplace: 4,
        outerBorderColor: '#676e73',
        outerBorderWidth: 1,
        textLine: 'none'
      }
    },
    {
      if: { focus: true },
      tokens: { outerBorderColor: '#676e73', outerBorderWidth: 3 }
    },
    {
      if: { selected: true },
      tokens: {
        backgroundColor: '#676e73',
        color: '#ffffff',
        textLine: 'none'
      }
    },
    {
      if: { pressed: true },
      tokens: { backgroundColor: '#676e73', color: '#ffffff' }
    },
    {
      if: { direction: 'previous' },
      tokens: { icon: PaletteIconArrowLeft }
    },
    {
      if: { direction: 'next' },
      tokens: { icon: PaletteIconArrowRight }
    }
  ],
  tokens: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
    borderBottomWidth: 0,
    borderColor: 'rgba(0, 0, 0, 0)',
    borderLeftWidth: 0,
    borderRadius: 4,
    borderRightWidth: 0,
    borderTopWidth: 0,
    color: '#676e73',
    displayLabel: true,
    fontName: 'HNforTELUSSA',
    fontSize: 16,
    fontWeight: '400',
    height: null,
    icon: null,
    iconDisplace: 0,
    iconSize: 24,
    lineHeight: 1.5,
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    outerBorderWidth: 1,
    paddingBottom: 4,
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 4,
    textAlign: 'center',
    textLine: 'none',
    width: null
  }
}
export default theme
